import React, { useEffect, useState } from 'react';
import { ethers } from 'ethers';
import { ARC_TESTNET_NETWORK } from '../config/blockchain';
import './NetworkStatus.css';

function NetworkStatus() {
  const [block, setBlock] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const provider = new ethers.JsonRpcProvider(ARC_TESTNET_NETWORK.rpcUrl);
    const tick = async () => {
      try {
        const n = await provider.getBlockNumber();
        if (!cancelled) setBlock(n);
      } catch {
        if (!cancelled) setBlock(null);
      }
    };
    tick();
    const id = setInterval(tick, 8000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return (
    <div className="network-status" title={`Network ${ARC_TESTNET_NETWORK.name} · chain ${ARC_TESTNET_NETWORK.chainIdDecimal}`}>
      <span className="network-status__pulse" />
      <span className="network-status__text">
        arc · testnet · chain {ARC_TESTNET_NETWORK.chainIdDecimal} · block {block !== null ? block.toLocaleString() : '—'}
      </span>
    </div>
  );
}

export default NetworkStatus;
